import { Button, Checkbox, Col, Form, notification, Row, Select, Spin, Table } from "antd";
import Title from "antd/es/typography/Title";
import { useAppDispatch, useAppSelector } from "app/config/store";
import { getSelectBox, reset } from "app/entities/category-report/category-report.reducer";
import { getOrgTree } from "app/entities/common/common.reducer";
import { exportExcelOneReportWithMultipleOrg } from "app/entities/objective/objective.reducer";
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { filterOption } from "app/shared/util/select-filter";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { exportExcelReportCompliance } from "../report-compliance.reducer";
import { overridePaginationStateWithQueryParams } from "app/shared/util/entity-utils";
import { getPaginationState } from "react-jhipster";
import { useLocation } from "react-router-dom";
import { DESC } from "app/shared/util/pagination.constants";
import { getEntities } from "app/entities/report-schedule/report-schedule.reducer";

export const ReportComplianceComponent = () => {
    const dispatch = useAppDispatch();
    const tree = useAppSelector(state => state.common.orgsTree);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const [isLoading, setLoading] = useState(true)


    const pageLocation = useLocation();

    const reportScheduleList = useAppSelector(state => state.reportSchedule.entities);
    const totalItems = useAppSelector(state => state.reportSchedule.totalItems);

    const [searchText, setSearchText] = useState();
    const [filters, setFilter] = useState<any>({ year: dayjs().year() });


    const loading = useAppSelector(state => state.reportCompliance.loading);

    const [form] = Form.useForm();

    useEffect(() => {
        // Load plan periods initially
        dispatch(getPlanPeriods({}));
        // Load report schedules with default year
        dispatch(getEntities({ year: dayjs().year() }));
    }, []);

    useEffect(() => {
        // Load report schedules when year filter changes
        if (filters?.year) {

            dispatch(getEntities({ year: filters.year, page: 1, size: 50 }));
        }
    }, [filters?.year]);

    const handleSubmit = values => {
        dispatch(
            exportExcelReportCompliance({
                planPeriodId: values.planPeriodId,
                reportScheduleId: values.reportScheduleId,
                year: values.year
            })).then(res => {
                if (res.payload) {
                    const resultExcel = res.payload as any;
                    saveAs(
                        new Blob([resultExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                        `Báo cáo tuân thủ_${dayjs().format('DDMMYYYYhhmmss')}`,
                    );
                }
            }).finally(() => { setLoading(false) });
    }


    const handleChangeYear = value => {
        const newFilters = { ...filters, year: value };
        setFilter(newFilters);
        // Clear the plan period selection when year changes
        form.setFieldsValue({ planPeriodId: undefined });
    }

    const handleChangePlanPeriod = value => {
        // Clear the report schedule selection when plan period changes
        form.setFieldsValue({ reportScheduleId: undefined });
    }

    return (
        <Spin spinning={loading} delay={300}>
            <Container className="form">
                <Title level={3}>XUẤT FILE BÁO CÁO TUÂN THỦ</Title>
                <Form size="large" form={form} initialValues={{ year: dayjs().year() }} onFinish={handleSubmit} layout="vertical">
                    <Row className='w-100 d-flex align-items-end' >
                        <Col md={5}>
                            <Form.Item name={'year'} label={'Năm'}>
                                <Select
                                    className="w-100"
                                    value={filters?.year}
                                    showSearch
                                    defaultValue={dayjs().year()}
                                    options={Array.from({ length: 10 }, (_, i) => {
                                        const year = dayjs().year() - 5 + i;
                                        return {
                                            value: year,
                                            label: year.toString(),
                                        };
                                    })}
                                    onChange={handleChangeYear}
                                    filterOption={filterOption}
                                    placeholder="Chọn năm"
                                    size="large"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={5}>
                            <Form.Item name={'reportScheduleId'} label={'Kỳ báo cáo'}>
                                <Select
                                    className="w-100"
                                    showSearch
                                    options={reportScheduleList.map(x => {
                                        return {
                                            value: x.id,
                                            label: x.name,
                                        };
                                    })}
                                    filterOption={filterOption}
                                    placeholder="Chọn kỳ báo cáo"
                                    size="large"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col className="d-flex align-items-end" style={{ marginBottom: '8px' }}>
                            <Button type="primary" htmlType="submit" disabled={false} size="large">
                                Xuất File
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </Spin>
    );
};
export default ReportComplianceComponent;